/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import { ProductReviewDrawerType, ProductReviewUiState } from '../../model';
import {
	addSliderState,
	cleanSliderState,
	closeProductReviewDrawer,
	closeReviewImageModal,
	openProductReviewDrawer,
	openReviewImageModal
} from '../actions';

export const initialProductReviewsState: ProductReviewUiState = {
	productListDrawer: { drawerType: ProductReviewDrawerType.NONE, open: false },
	imageModal: false,
	slider: {
		media: undefined,
		review: undefined,
		position: {
			previous: null,
			current: 0,
			next: null
		}
	}
};

export const productReviewsUiReducers = createReducer(
	initialProductReviewsState,
	on(openProductReviewDrawer, (state, { drawerType }) => ({
		...state,
		productListDrawer: { drawerType, open: true }
	})),
	on(closeProductReviewDrawer, (state) => ({
		...state,
		productListDrawer: initialProductReviewsState.productListDrawer
	})),
	on(addSliderState, (state, { slider }) => ({
		...state,
		slider
	})),
	on(cleanSliderState, (state) => ({
		...state,
		slider: initialProductReviewsState.slider
	})),
	on(openReviewImageModal, (state) => ({
		...state,
		imageModal: true
	})),
	on(closeReviewImageModal, (state) => ({
		...state,
		imageModal: false
	}))
);

export const productReviewsUiReducer = (state: ProductReviewUiState, action: Action) =>
	productReviewsUiReducers(state, action);
